import React from 'react';
import { useAuth } from '../AuthContext';
import { useAxios } from '../core/_axios';
import useAccount from '../hooks/useAccount';
import { isPaymentOutOfDate, getAgencyName } from '../utils/paymentUtils';

export default function PaymentWarningBanner() {
    const { currentUser, viewingAllAccounts } = useAuth();
    const axios = useAxios();
    const { account } = useAccount({
        axios,
        isForCurrentAccount: !viewingAllAccounts
    });

    // Check both user's agency and current account's agency
    const paymentOutOfDate = isPaymentOutOfDate(currentUser, account);

    if (!paymentOutOfDate) {
        return null;
    }

    // Different messages for agency admins vs regular users
    const isAgencyAdmin = currentUser?.is_agency_admin === true;
    const agencyName = getAgencyName(currentUser, account);

    const message = isAgencyAdmin
        ? `Payment for ${agencyName} is past due. Please contact your SGB admin.`
        : `Payment for ${agencyName} is past due. Please contact your agency administrator.`;

    return (
        <div className="bg-red-600 text-white">
            <div className="container-fixed py-4">
                <div className="flex items-start gap-4">
                    <i className="ki-filled ki-information-circle text-3xl flex-shrink-0 mt-0.5"></i>
                    <div className="flex-1 min-w-0">
                        <h4 className="font-semibold text-base mb-1.5">Payment Required</h4>
                        <p className="text-sm leading-relaxed opacity-95">{message}</p>
                    </div>
                </div>
            </div>
        </div>
    );
}
